// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3D_U7","emails":"CreateEditClinics_emails__omis2","emailTagLabel":"CreateEditClinics_emailTagLabel__2s11Q"};